module.exports = __webpack_public_path__ + "static/mfa-df27e9bcff2ee1a59d63c683185ed3ac.jpg";